export default __webpack_public_path__ + "static/media/careadmin_doctor_icon.b3439af0.svg";